<div class="purchase-container">
  <div class="breadcrumb-header">
    <div class="breadcrumb">
      <span class="text-muted" routerLink="/company-admin/billing-payments">{{ 'dash.billingTitle' | translate }}</span>
      <i class="bi bi-chevron-right mx-2 text-muted" style="font-size: 12px;"></i>
      <span class="text-muted">{{ 'dash.talentAssessment' | translate }}</span>
      <i class="bi bi-chevron-right mx-2 text-muted" style="font-size: 12px;"></i>
      <span>{{ 'dash.purchaseBreadcrumb' | translate }}</span>
    </div>
    <button class="btn-back" routerLink="/company-admin/billing-payments">
      <i class="bi bi-arrow-left"></i> {{ 'dash.back' | translate }}
    </button>
  </div>

  <div class="page-title">
    <h1>{{ 'dash.chooseTalentPackage' | translate }}</h1>
    <p class="subtitle">{{ 'dash.choosePackageStart' | translate }}</p>
  </div>

  <div class="purchase-box">
    <div class="info-message">
      <i class="bi bi-info-circle"></i>
      <h3>{{ 'dash.talentNotPublished' | translate }}</h3>
      <p>{{ 'dash.packagesComing' | translate }}</p>
    </div>

    <div class="skeleton-cards">
      <div class="skeleton-card"></div>
      <div class="skeleton-card"></div>
      <div class="skeleton-card"></div>
    </div>
  </div>
  
  <div class="footer-actions">
    <button class="btn-outline-gray" routerLink="/company-admin/billing-payments">{{ 'dash.backToBilling' | translate }}</button>
  </div>
</div>
